export default (method, docs, ext_url) => {
    if(!method) return null
    if(method.name.toLowerCase().includes('external') && ext_url){
      let url = ext_url.uri ? ext_url.uri : ext_url;
      return ['external', url]
    }else if(method.name.toLowerCase().includes('board') && docs && docs.length){
      return ['board', docs]
    }
  }